var cov_27ojsu2bnk = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/Container.tsx",
      hash = "5383cb684e39633817327e687fe08031319c3e34",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/Container.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 19,
          column: 30
        },
        end: {
          line: 19,
          column: 31
        }
      },
      "2": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 16
        }
      },
      "3": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 19
        }
      },
      "4": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 50
        }
      },
      "5": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 50
        }
      },
      "6": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 52
        }
      },
      "7": {
        start: {
          line: 40,
          column: 57
        },
        end: {
          line: 40,
          column: 67
        }
      },
      "8": {
        start: {
          line: 41,
          column: 17
        },
        end: {
          line: 41,
          column: 25
        }
      },
      "9": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 36
        }
      },
      "10": {
        start: {
          line: 42,
          column: 16
        },
        end: {
          line: 42,
          column: 36
        }
      },
      "11": {
        start: {
          line: 44,
          column: 45
        },
        end: {
          line: 44,
          column: 50
        }
      },
      "12": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 52
        }
      },
      "13": {
        start: {
          line: 45,
          column: 34
        },
        end: {
          line: 45,
          column: 52
        }
      },
      "14": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 63
        }
      },
      "15": {
        start: {
          line: 46,
          column: 41
        },
        end: {
          line: 46,
          column: 63
        }
      },
      "16": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 26
        }
      },
      "17": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 26
        }
      },
      "18": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 55,
          column: 93
        }
      },
      "19": {
        start: {
          line: 55,
          column: 87
        },
        end: {
          line: 55,
          column: 93
        }
      },
      "20": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 35
        }
      },
      "21": {
        start: {
          line: 56,
          column: 29
        },
        end: {
          line: 56,
          column: 35
        }
      },
      "22": {
        start: {
          line: 58,
          column: 86
        },
        end: {
          line: 58,
          column: 96
        }
      },
      "23": {
        start: {
          line: 59,
          column: 17
        },
        end: {
          line: 59,
          column: 58
        }
      },
      "24": {
        start: {
          line: 60,
          column: 14
        },
        end: {
          line: 60,
          column: 104
        }
      },
      "25": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 63,
          column: 5
        }
      },
      "26": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 19
        }
      },
      "27": {
        start: {
          line: 65,
          column: 35
        },
        end: {
          line: 65,
          column: 62
        }
      },
      "28": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "29": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 39
        }
      },
      "30": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 12
        }
      },
      "31": {
        start: {
          line: 71,
          column: 19
        },
        end: {
          line: 71,
          column: 34
        }
      },
      "32": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 32
        }
      },
      "33": {
        start: {
          line: 72,
          column: 26
        },
        end: {
          line: 72,
          column: 32
        }
      },
      "34": {
        start: {
          line: 73,
          column: 18
        },
        end: {
          line: 73,
          column: 29
        }
      },
      "35": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 75,
          column: 23
        }
      },
      "36": {
        start: {
          line: 74,
          column: 24
        },
        end: {
          line: 74,
          column: 38
        }
      },
      "37": {
        start: {
          line: 75,
          column: 9
        },
        end: {
          line: 75,
          column: 23
        }
      },
      "38": {
        start: {
          line: 77,
          column: 4
        },
        end: {
          line: 77,
          column: 39
        }
      },
      "39": {
        start: {
          line: 81,
          column: 22
        },
        end: {
          line: 81,
          column: 32
        }
      },
      "40": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 85,
          column: 5
        }
      },
      "41": {
        start: {
          line: 83,
          column: 6
        },
        end: {
          line: 83,
          column: 39
        }
      },
      "42": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 12
        }
      },
      "43": {
        start: {
          line: 86,
          column: 19
        },
        end: {
          line: 86,
          column: 34
        }
      },
      "44": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 87,
          column: 32
        }
      },
      "45": {
        start: {
          line: 87,
          column: 26
        },
        end: {
          line: 87,
          column: 32
        }
      },
      "46": {
        start: {
          line: 88,
          column: 18
        },
        end: {
          line: 88,
          column: 29
        }
      },
      "47": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 22
        }
      },
      "48": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 39
        }
      },
      "49": {
        start: {
          line: 99,
          column: 66
        },
        end: {
          line: 99,
          column: 76
        }
      },
      "50": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 100,
          column: 57
        }
      },
      "51": {
        start: {
          line: 100,
          column: 46
        },
        end: {
          line: 100,
          column: 57
        }
      },
      "52": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 110,
          column: 5
        }
      },
      "53": {
        start: {
          line: 105,
          column: 10
        },
        end: {
          line: 107,
          column: 16
        }
      },
      "54": {
        start: {
          line: 114,
          column: 85
        },
        end: {
          line: 114,
          column: 95
        }
      },
      "55": {
        start: {
          line: 115,
          column: 22
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "56": {
        start: {
          line: 120,
          column: 16
        },
        end: {
          line: 120,
          column: 31
        }
      },
      "57": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 49
        }
      },
      "58": {
        start: {
          line: 121,
          column: 31
        },
        end: {
          line: 121,
          column: 49
        }
      },
      "59": {
        start: {
          line: 123,
          column: 19
        },
        end: {
          line: 123,
          column: 24
        }
      },
      "60": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 61
        }
      },
      "61": {
        start: {
          line: 124,
          column: 18
        },
        end: {
          line: 124,
          column: 61
        }
      },
      "62": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 154,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 15
          },
          end: {
            line: 19,
            column: 16
          }
        },
        loc: {
          start: {
            line: 19,
            column: 30
          },
          end: {
            line: 19,
            column: 31
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 44
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 13
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 39
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 34
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 50
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 54,
            column: 2
          },
          end: {
            line: 54,
            column: 3
          }
        },
        loc: {
          start: {
            line: 54,
            column: 51
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 54
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        loc: {
          start: {
            line: 80,
            column: 42
          },
          end: {
            line: 91,
            column: 3
          }
        },
        line: 80
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 98,
            column: 3
          }
        },
        loc: {
          start: {
            line: 98,
            column: 16
          },
          end: {
            line: 111,
            column: 3
          }
        },
        line: 98
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 104,
            column: 19
          },
          end: {
            line: 104,
            column: 20
          }
        },
        loc: {
          start: {
            line: 105,
            column: 10
          },
          end: {
            line: 107,
            column: 16
          }
        },
        line: 105
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 113,
            column: 2
          },
          end: {
            line: 113,
            column: 3
          }
        },
        loc: {
          start: {
            line: 113,
            column: 11
          },
          end: {
            line: 155,
            column: 3
          }
        },
        line: 113
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 40,
            column: 26
          },
          end: {
            line: 40,
            column: 52
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 40,
            column: 34
          },
          end: {
            line: 40,
            column: 52
          }
        }],
        line: 40
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 36
          }
        }, {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 42,
            column: 36
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 42,
            column: 23
          },
          end: {
            line: 42,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 23
          },
          end: {
            line: 42,
            column: 28
          }
        }, {
          start: {
            line: 42,
            column: 32
          },
          end: {
            line: 42,
            column: 36
          }
        }],
        line: 42
      },
      "3": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 52
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 52
          }
        }],
        line: 45
      },
      "4": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 13
          }
        }, {
          start: {
            line: 45,
            column: 17
          },
          end: {
            line: 45,
            column: 32
          }
        }],
        line: 45
      },
      "5": {
        loc: {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 63
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 63
          }
        }, {
          start: {
            line: 46,
            column: 4
          },
          end: {
            line: 46,
            column: 63
          }
        }],
        line: 46
      },
      "6": {
        loc: {
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 46,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 46,
            column: 8
          },
          end: {
            line: 46,
            column: 20
          }
        }, {
          start: {
            line: 46,
            column: 24
          },
          end: {
            line: 46,
            column: 39
          }
        }],
        line: 46
      },
      "7": {
        loc: {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 93
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 93
          }
        }, {
          start: {
            line: 55,
            column: 4
          },
          end: {
            line: 55,
            column: 93
          }
        }],
        line: 55
      },
      "8": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 35
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 35
          }
        }],
        line: 56
      },
      "9": {
        loc: {
          start: {
            line: 58,
            column: 12
          },
          end: {
            line: 58,
            column: 38
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 58,
            column: 20
          },
          end: {
            line: 58,
            column: 38
          }
        }],
        line: 58
      },
      "10": {
        loc: {
          start: {
            line: 58,
            column: 40
          },
          end: {
            line: 58,
            column: 64
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 58,
            column: 47
          },
          end: {
            line: 58,
            column: 64
          }
        }],
        line: 58
      },
      "11": {
        loc: {
          start: {
            line: 60,
            column: 14
          },
          end: {
            line: 60,
            column: 104
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 60,
            column: 25
          },
          end: {
            line: 60,
            column: 65
          }
        }, {
          start: {
            line: 60,
            column: 68
          },
          end: {
            line: 60,
            column: 104
          }
        }],
        line: 60
      },
      "12": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }],
        line: 61
      },
      "13": {
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 28
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 15
          }
        }, {
          start: {
            line: 61,
            column: 19
          },
          end: {
            line: 61,
            column: 28
          }
        }],
        line: 61
      },
      "14": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 67
      },
      "15": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 32
          }
        }, {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 72,
            column: 32
          }
        }],
        line: 72
      },
      "16": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 75,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 75,
            column: 23
          }
        }, {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 75,
            column: 23
          }
        }],
        line: 74
      },
      "17": {
        loc: {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }, {
          start: {
            line: 82,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }],
        line: 82
      },
      "18": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 32
          }
        }, {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 87,
            column: 32
          }
        }],
        line: 87
      },
      "19": {
        loc: {
          start: {
            line: 99,
            column: 35
          },
          end: {
            line: 99,
            column: 61
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 99,
            column: 43
          },
          end: {
            line: 99,
            column: 61
          }
        }],
        line: 99
      },
      "20": {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 57
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 57
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 100,
            column: 57
          }
        }],
        line: 100
      },
      "21": {
        loc: {
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 20
          }
        }, {
          start: {
            line: 100,
            column: 24
          },
          end: {
            line: 100,
            column: 44
          }
        }],
        line: 100
      },
      "22": {
        loc: {
          start: {
            line: 103,
            column: 62
          },
          end: {
            line: 103,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 103,
            column: 62
          },
          end: {
            line: 103,
            column: 71
          }
        }, {
          start: {
            line: 103,
            column: 75
          },
          end: {
            line: 103,
            column: 81
          }
        }],
        line: 103
      },
      "23": {
        loc: {
          start: {
            line: 114,
            column: 44
          },
          end: {
            line: 114,
            column: 70
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 114,
            column: 52
          },
          end: {
            line: 114,
            column: 70
          }
        }],
        line: 114
      },
      "24": {
        loc: {
          start: {
            line: 116,
            column: 23
          },
          end: {
            line: 116,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 23
          },
          end: {
            line: 116,
            column: 31
          }
        }, {
          start: {
            line: 116,
            column: 35
          },
          end: {
            line: 116,
            column: 45
          }
        }],
        line: 116
      },
      "25": {
        loc: {
          start: {
            line: 116,
            column: 47
          },
          end: {
            line: 116,
            column: 80
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 47
          },
          end: {
            line: 116,
            column: 66
          }
        }, {
          start: {
            line: 116,
            column: 70
          },
          end: {
            line: 116,
            column: 80
          }
        }],
        line: 116
      },
      "26": {
        loc: {
          start: {
            line: 116,
            column: 82
          },
          end: {
            line: 116,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 82
          },
          end: {
            line: 116,
            column: 89
          }
        }, {
          start: {
            line: 116,
            column: 93
          },
          end: {
            line: 116,
            column: 98
          }
        }],
        line: 116
      },
      "27": {
        loc: {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 121,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 121,
            column: 49
          }
        }, {
          start: {
            line: 121,
            column: 4
          },
          end: {
            line: 121,
            column: 49
          }
        }],
        line: 121
      },
      "28": {
        loc: {
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 124,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 124,
            column: 61
          }
        }, {
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 124,
            column: 61
          }
        }],
        line: 124
      },
      "29": {
        loc: {
          start: {
            line: 130,
            column: 11
          },
          end: {
            line: 140,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 130,
            column: 11
          },
          end: {
            line: 130,
            column: 16
          }
        }, {
          start: {
            line: 131,
            column: 12
          },
          end: {
            line: 139,
            column: 14
          }
        }],
        line: 130
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0],
      "10": [0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/Container.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { isRTL } from '../config';
import { sliderClass } from './styles';
import Slider from './Slider';
import { per2value } from './utils';
import getDataset from '../utils/dom/getDataset';
import { getDirectionClass } from '../utils/classname';
import { isFunc, isArray } from '../utils/is';
var DefaultValue = (cov_27ojsu2bnk.s[0]++, {
  height: 200,
  scale: [0, 100],
  step: 1,
  vertical: false,
  formatScale: function formatScale(v) {
    cov_27ojsu2bnk.f[0]++;
    cov_27ojsu2bnk.s[1]++;
    return v;
  }
});

var Container =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Container, _PureComponent);

  var _super = _createSuper2(Container);

  function Container(props) {
    var _this;

    _classCallCheck(this, Container);

    cov_27ojsu2bnk.f[1]++;
    cov_27ojsu2bnk.s[2]++;
    _this = _super.call(this, props);
    _this.innerElement = void 0;
    cov_27ojsu2bnk.s[3]++;
    _this.state = {};
    cov_27ojsu2bnk.s[4]++;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_this));
    cov_27ojsu2bnk.s[5]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    cov_27ojsu2bnk.s[6]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this)); // this.handleFirstDrag = this.handleDrag.bind(this, 0)
    // this.handleSecondDrag = this.handleDrag.bind(this, 1)

    return _this;
  }

  _createClass(Container, [{
    key: "getValue",
    value: function getValue() {
      cov_27ojsu2bnk.f[2]++;

      var _ref = (cov_27ojsu2bnk.s[7]++, this.props),
          range = _ref.range,
          value = _ref.value,
          _ref$scale = _ref.scale,
          scale = _ref$scale === void 0 ? (cov_27ojsu2bnk.b[0][0]++, DefaultValue.scale) : _ref$scale;

      var from = (cov_27ojsu2bnk.s[8]++, scale[0]);
      cov_27ojsu2bnk.s[9]++;

      if (!range) {
        cov_27ojsu2bnk.b[1][0]++;
        cov_27ojsu2bnk.s[10]++;
        return (cov_27ojsu2bnk.b[2][0]++, value) || (cov_27ojsu2bnk.b[2][1]++, from);
      } else {
        cov_27ojsu2bnk.b[1][1]++;
      }

      var val = (cov_27ojsu2bnk.s[11]++, value);
      cov_27ojsu2bnk.s[12]++;

      if ((cov_27ojsu2bnk.b[4][0]++, range) && (cov_27ojsu2bnk.b[4][1]++, !isArray(value))) {
        cov_27ojsu2bnk.b[3][0]++;
        cov_27ojsu2bnk.s[13]++;
        val = [from, from];
      } else {
        cov_27ojsu2bnk.b[3][1]++;
      }

      cov_27ojsu2bnk.s[14]++;

      if ((cov_27ojsu2bnk.b[6][0]++, isArray(val)) && (cov_27ojsu2bnk.b[6][1]++, val[0] > val[1])) {
        cov_27ojsu2bnk.b[5][0]++;
        cov_27ojsu2bnk.s[15]++;
        val = [val[1], val[0]];
      } else {
        cov_27ojsu2bnk.b[5][1]++;
      }

      cov_27ojsu2bnk.s[16]++;
      return val;
    }
  }, {
    key: "bindElement",
    value: function bindElement(el) {
      cov_27ojsu2bnk.f[3]++;
      cov_27ojsu2bnk.s[17]++;
      this.innerElement = el;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      cov_27ojsu2bnk.f[4]++;
      cov_27ojsu2bnk.s[18]++;

      if (e.target.className.indexOf(sliderClass('indicator')) >= 0) {
        cov_27ojsu2bnk.b[7][0]++;
        cov_27ojsu2bnk.s[19]++;
        return;
      } else {
        cov_27ojsu2bnk.b[7][1]++;
      }

      cov_27ojsu2bnk.s[20]++;

      if (this.props.disabled) {
        cov_27ojsu2bnk.b[8][0]++;
        cov_27ojsu2bnk.s[21]++;
        return;
      } else {
        cov_27ojsu2bnk.b[8][1]++;
      }

      var _ref2 = (cov_27ojsu2bnk.s[22]++, this.props),
          _ref2$scale = _ref2.scale,
          scale = _ref2$scale === void 0 ? (cov_27ojsu2bnk.b[9][0]++, DefaultValue.scale) : _ref2$scale,
          _ref2$step = _ref2.step,
          step = _ref2$step === void 0 ? (cov_27ojsu2bnk.b[10][0]++, DefaultValue.step) : _ref2$step,
          vertical = _ref2.vertical,
          range = _ref2.range;

      var rect = (cov_27ojsu2bnk.s[23]++, this.innerElement.getBoundingClientRect());
      var per = (cov_27ojsu2bnk.s[24]++, vertical ? (cov_27ojsu2bnk.b[11][0]++, 1 - (e.clientY - rect.top) / rect.height) : (cov_27ojsu2bnk.b[11][1]++, (e.clientX - rect.left) / rect.width));
      cov_27ojsu2bnk.s[25]++;

      if ((cov_27ojsu2bnk.b[13][0]++, isRTL()) && (cov_27ojsu2bnk.b[13][1]++, !vertical)) {
        cov_27ojsu2bnk.b[12][0]++;
        cov_27ojsu2bnk.s[26]++;
        per = 1 - per;
      } else {
        cov_27ojsu2bnk.b[12][1]++;
      }

      var val = (cov_27ojsu2bnk.s[27]++, per2value(per, scale, step));
      cov_27ojsu2bnk.s[28]++;

      if (!range) {
        cov_27ojsu2bnk.b[14][0]++;
        cov_27ojsu2bnk.s[29]++;
        this.props.onChange(val);
        cov_27ojsu2bnk.s[30]++;
        return;
      } else {
        cov_27ojsu2bnk.b[14][1]++;
      }

      var values = (cov_27ojsu2bnk.s[31]++, this.getValue());
      cov_27ojsu2bnk.s[32]++;

      if (!isArray(values)) {
        cov_27ojsu2bnk.b[15][0]++;
        cov_27ojsu2bnk.s[33]++;
        return;
      } else {
        cov_27ojsu2bnk.b[15][1]++;
      }

      var value = (cov_27ojsu2bnk.s[34]++, _toConsumableArray(values));
      cov_27ojsu2bnk.s[35]++;

      if (val < value[0]) {
        cov_27ojsu2bnk.b[16][0]++;
        cov_27ojsu2bnk.s[36]++;
        value[0] = val;
      } else {
        cov_27ojsu2bnk.b[16][1]++;
        cov_27ojsu2bnk.s[37]++;
        value[1] = val;
      }

      cov_27ojsu2bnk.s[38]++;
      this.props.onChange(value);
    }
  }, {
    key: "handleChange",
    value: function handleChange(index, val) {
      cov_27ojsu2bnk.f[5]++;

      var _ref3 = (cov_27ojsu2bnk.s[39]++, this.props),
          range = _ref3.range;

      cov_27ojsu2bnk.s[40]++;

      if (!range) {
        cov_27ojsu2bnk.b[17][0]++;
        cov_27ojsu2bnk.s[41]++;
        this.props.onChange(val);
        cov_27ojsu2bnk.s[42]++;
        return;
      } else {
        cov_27ojsu2bnk.b[17][1]++;
      }

      var values = (cov_27ojsu2bnk.s[43]++, this.getValue());
      cov_27ojsu2bnk.s[44]++;

      if (!isArray(values)) {
        cov_27ojsu2bnk.b[18][0]++;
        cov_27ojsu2bnk.s[45]++;
        return;
      } else {
        cov_27ojsu2bnk.b[18][1]++;
      }

      var value = (cov_27ojsu2bnk.s[46]++, _toConsumableArray(values));
      cov_27ojsu2bnk.s[47]++;
      value[index] = val;
      cov_27ojsu2bnk.s[48]++;
      this.props.onChange(value);
    } // handleDrag(index, value) {
    //   const { range } = this.props
    //   if (!range) this.props.onDrag(value)
    // }

  }, {
    key: "renderScale",
    value: function renderScale() {
      var _this2 = this;

      cov_27ojsu2bnk.f[6]++;

      var _ref4 = (cov_27ojsu2bnk.s[49]++, this.props),
          autoHide = _ref4.autoHide,
          formatScale = _ref4.formatScale,
          _ref4$scale = _ref4.scale,
          scale = _ref4$scale === void 0 ? (cov_27ojsu2bnk.b[19][0]++, DefaultValue.scale) : _ref4$scale;

      cov_27ojsu2bnk.s[50]++;

      if ((cov_27ojsu2bnk.b[21][0]++, !formatScale) || (cov_27ojsu2bnk.b[21][1]++, !isFunc(formatScale))) {
        cov_27ojsu2bnk.b[20][0]++;
        cov_27ojsu2bnk.s[51]++;
        return null;
      } else {
        cov_27ojsu2bnk.b[20][1]++;
      }

      cov_27ojsu2bnk.s[52]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: sliderClass(getDirectionClass('scale'), (cov_27ojsu2bnk.b[22][0]++, !autoHide) && (cov_27ojsu2bnk.b[22][1]++, 'show')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103,
            columnNumber: 7
          }
        }, scale.map(function (s, i) {
          cov_27ojsu2bnk.f[7]++;
          cov_27ojsu2bnk.s[53]++;
          return (
            /*#__PURE__*/
            React.createElement("div", {
              key: s,
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 105,
                columnNumber: 11
              }
            },
            /*#__PURE__*/
            React.createElement("span", {
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 106,
                columnNumber: 13
              }
            }, formatScale(s, i)))
          );
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_27ojsu2bnk.f[8]++;

      var _ref5 = (cov_27ojsu2bnk.s[54]++, this.props),
          range = _ref5.range,
          height = _ref5.height,
          style = _ref5.style,
          vertical = _ref5.vertical,
          _ref5$scale = _ref5.scale,
          scale = _ref5$scale === void 0 ? (cov_27ojsu2bnk.b[23][0]++, DefaultValue.scale) : _ref5$scale,
          other = _objectWithoutProperties(_ref5, ["range", "height", "style", "vertical", "scale"]);

      var className = (cov_27ojsu2bnk.s[55]++, classnames(sliderClass('_', (cov_27ojsu2bnk.b[24][0]++, vertical) && (cov_27ojsu2bnk.b[24][1]++, 'vertical'), (cov_27ojsu2bnk.b[25][0]++, this.props.disabled) && (cov_27ojsu2bnk.b[25][1]++, 'disabled'), (cov_27ojsu2bnk.b[26][0]++, isRTL()) && (cov_27ojsu2bnk.b[26][1]++, 'rtl')), this.props.className));
      var value = (cov_27ojsu2bnk.s[56]++, this.getValue());
      cov_27ojsu2bnk.s[57]++;

      if (!Array.isArray(value)) {
        cov_27ojsu2bnk.b[27][0]++;
        cov_27ojsu2bnk.s[58]++;
        value = [0, value];
      } else {
        cov_27ojsu2bnk.b[27][1]++;
      }

      var newStyle = (cov_27ojsu2bnk.s[59]++, style);
      cov_27ojsu2bnk.s[60]++;

      if (vertical) {
        cov_27ojsu2bnk.b[28][0]++;
        cov_27ojsu2bnk.s[61]++;
        newStyle = Object.assign({
          height: height
        }, style);
      } else {
        cov_27ojsu2bnk.b[28][1]++;
      }

      cov_27ojsu2bnk.s[62]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          style: newStyle,
          className: className
        }, getDataset(other), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 127,
            columnNumber: 7
          }
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: sliderClass('background'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 128,
            columnNumber: 9
          }
        }),
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindElement,
          onClick: this.handleClick,
          className: sliderClass('inner'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 129,
            columnNumber: 9
          }
        }, (cov_27ojsu2bnk.b[29][0]++, range) && (cov_27ojsu2bnk.b[29][1]++,
        /*#__PURE__*/
        React.createElement(Slider, Object.assign({}, other, {
          index: 0,
          scale: scale,
          max: value[1],
          onChange: this.handleChange,
          value: value[0],
          vertical: vertical,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 131,
            columnNumber: 13
          }
        }))),
        /*#__PURE__*/
        React.createElement(Slider, Object.assign({}, other, {
          index: 1,
          scale: scale,
          min: value[0],
          onChange: this.handleChange,
          value: value[1],
          vertical: vertical,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 142,
            columnNumber: 11
          }
        }))), this.renderScale())
      );
    }
  }]);

  return Container;
}(PureComponent);

Container.defaultProps = DefaultValue;
export default Container;